import React from "react";
import styles from "./StepCabine.module.scss";
import { FaUserAlt } from "react-icons/fa";
import InputForms from "components/UiComponents/forms/InputForms";


const StepCabine = ({ userData, updateUserData, onNext, onPrev }) => {

    return (
        <div className={styles.container}>
            <InputForms
                type="text"
                placeholder="Cabine"
                value={userData.cabine}
                onChange={(e) => updateUserData({ cabine: e.target.value })}
                required
                svg={<FaUserAlt />}
            />

            <select
                onChange={(e) => updateUserData({ typeCabine: e.target.value })}
                value={userData.typeCabine}
            >
                <option value="consulting">Consulting</option>
                <option value="reception">Récéption</option>
                <option value="demonstration">Démonstration</option>
            </select>

        </div>
    );
};

export default StepCabine;
